import type * as React from 'react';

export interface HTMLPreviewProps {
  html: string;
}

export const HTMLPreview = (props: HTMLPreviewProps): React.JSX.Element => {
  return (
    <iframe
      className="border rounded border-secondary w-100 d-block"
      onLoad={(e) => {
        e.currentTarget.style.height =
          e.currentTarget.contentWindow.document.documentElement.scrollHeight + 'px';
        e.currentTarget.contentWindow.document.querySelector('body').style.fontFamily =
          'Montserrat, Arial, Helvetica, sans-serif';
      }}
      srcDoc={props.html}
    />
  );
};
